import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
	selector: 'app-add-borrower',
	templateUrl: './add-borrower.component.html',
	styleUrls: ['./add-borrower.component.scss']
})
export class AddBorrowerComponent implements OnInit {

	@Input() qID: any = null;
	@Input() index: number;
	@Input() borrower: FormGroup;
	@Output() removed: EventEmitter<number> = new EventEmitter<number>();
	@Input() displayErrors: boolean;
	@Input() public childrenNumber: number[];
	@Input() public maritalStatus: string[];
	@Input() public showRemove: boolean;

	proximity: string[] = ["בן/בת זוג", "בן","אח", "חברים", "שותפים עסקיים", "אחר"];
	minBirthDate = {year: (new Date().getFullYear())-100, month: 1, day: 1}; //from -100 years
	maxBirthDate = {year: (new Date().getFullYear())-15, month: 12, day: 31};  //to 15 years old
	defaultValue = "";
	isMobilePhone;

	constructor() { }

	ngOnInit() {
	}

	static buildBorrower(val: any) {
		return new FormGroup({
			borrowerProximity: new FormControl(val ? val.borrowerProximity : ""),
			borrowerFullName: new FormControl(val ? val.borrowerFullName : ""),
			borrowerIdNumber: new FormControl(val ? val.borrowerIdNumber : ""),
			borrowerPhoneNumber: new FormControl(val ? val.borrowerPhoneNumber : ""),
			borrowerBirthDate: new FormControl(val ? val.borrowerBirthDate : ""),
			borrowerEmail: new FormControl(val ? val.borrowerEmail : ""),
			borrowerId: new FormControl(val ? val.borrowerId : ""),

		})
	}
}



// WEBPACK FOOTER //
// ./src/app/add-borrower/add-borrower.component.ts